import React, { useEffect, useRef, useState } from 'react';
import * as PropTypes from 'prop-types';
import templateSettings from 'lodash/templateSettings';
import template from 'lodash/template';
import { Loading } from '../Loading/Loading';
import { PrintIcon } from '../Common/Icons';
import './Viewer.scss';

const Viewer = ({ baseUrl, page, url, templateParams, boxClass, id, onLoad, pageName }) => {
  const iframeEl = useRef(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (iframeEl && iframeEl.current) {
      iframeEl.current.addEventListener('load', () => {
        setLoading(false);
        // Call onLoad callback when iframe finishes loading
        if (onLoad && pageName) {
          onLoad(pageName);
        }
      });

      if (templateParams) {
        templateSettings.interpolate = /\{\{(.+?)\}\}/g;
        iframeEl.current.addEventListener('load', function () {
          const iframe =
            iframeEl.current.contentDocument ||
            iframeEl.current.contentWindow.document;
          iframe.body.innerHTML = template(iframe.body.innerHTML)(
            templateParams
          );
          iframe.body.dispatchEvent(new window.Event('load'));
        });
      }
    }
  });

  if (page) {
    url = `${baseUrl}/${page}.html`;
  }

  const docType = url.substring(url.lastIndexOf('.') + 1);

  if (url.length) {
    return (
      <div className="overflow-hidden flex-grow-1 d-flex h-100">
        {loading && <Loading />}
        {id === 'outputs' && docType === 'html' && (
          <button
            className="viewer-print-button btn btn-outline-secondary"
            title="Print"
            onClick={() => iframeEl.current.contentWindow.print()}
          >
            <PrintIcon /> Print
          </button>
        )}
        <iframe
          key={url}
          ref={iframeEl}
          title="viewer"
          src={url}
          style={{ border: 0 }}
          className="flex-grow-1"
          tabIndex="0"
        />
      </div>
    );
  } else {
    return <div className="box watermark" />;
  }
};

Viewer.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  page: PropTypes.string,
  url: PropTypes.string,
  templateParams: PropTypes.object,
  boxClass: PropTypes.oneOf([
    'box-col',
    'box-row',
    'box-min',
    'box-stretch',
    '',
  ]),
  onLoad: PropTypes.func,
  pageName: PropTypes.string,
};
Viewer.defaultProps = {
  baseUrl: '',
  page: undefined,
  url: '',
  boxClass: '',
  size: 100,
  onLoad: null,
  pageName: '',
};

export default Viewer;
